import React from "react";
import { useIntl } from "react-intl";
import { LeftOutlined } from "@ant-design/icons";
import type { Category, CategoryConfig } from "../../../types/category";
import { usePageTheme } from "./theme/usePageTheme";
import CategoryIcon from "../shared/CategoryIcon";
import V2PageFrame from "./components/V2PageFrame";
import V2Header from "./components/V2Header";
import { V2_LAYOUT } from "./styles/v2Layout";

interface UCCategoryPageProps {
  categoryData?: Category;
  userName?: string;
  hideHeader?: boolean;
  onCategorySelect: (config: CategoryConfig) => void;
  onStartWithoutCategory?: () => void;
  onClose: () => void;
}

const UCCategoryPage: React.FC<UCCategoryPageProps> = ({
  categoryData,
  userName,
  hideHeader = false,
  onCategorySelect,
  onStartWithoutCategory,
  onClose,
}) => {
  const intl = useIntl();
  const { tokens } = usePageTheme();
  const configs = categoryData?.configs ?? [];

  const title =
    categoryData?.title ||
    intl.formatMessage({
      id: "v2.select_category",
      defaultMessage: "Please Select ServiceCategory",
    });

  return (
    <V2PageFrame
      header={
        hideHeader ? undefined : (
          <V2Header
            title={intl.formatMessage({
              id: "v2.customer_support",
              defaultMessage: "Customer Support",
            })}
            left={
              <button
                type="button"
                onClick={onClose}
                style={{
                  border: "none",
                  background: "transparent",
                  color: tokens.text,
                  cursor: "pointer",
                  padding: 8,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <LeftOutlined style={{ fontSize: 18 }} />
              </button>
            }
          />
        )
      }
    >
      {/* 设计稿：顶栏下方黑色内容区 */}
      <div
        style={{
          flex: 1,
          background: tokens.background,
          padding: `0 ${V2_LAYOUT.categoryPaddingX}px 24px`,
        }}
      >
        {userName ? (
          <div
            style={{
              marginTop: 16,
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "26px",
              color: tokens.text,
            }}
          >
            {`Hi,${userName}`}
          </div>
        ) : null}

        <div
          style={{
            marginTop: userName ? 4 : 16,
            fontSize: 16,
            fontWeight: 600,
            lineHeight: "22px",
            color: tokens.text,
            marginBottom: 16,
          }}
        >
          {title}
        </div>

        {configs.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: V2_LAYOUT.categoryCardGap,
            }}
          >
            {configs.map((config, index) => (
              <button
                key={`${config.name}-${index}`}
                type="button"
                onClick={() => onCategorySelect(config)}
                style={{
                  width: "100%",
                  height: V2_LAYOUT.categoryCardHeight,
                  border: "none",
                  borderRadius: 0,
                  background: tokens.cardBg,
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  paddingTop: 8,
                  paddingBottom: 12,
                  color: tokens.text,
                }}
              >
                <CategoryIcon config={config} size={V2_LAYOUT.categoryIconSize} />
                <span
                  style={{
                    marginTop: 10,
                    fontSize: 14,
                    fontWeight: 600,
                    textAlign: "center",
                    lineHeight: 1.35,
                    whiteSpace: "pre-line",
                    padding: "0 8px",
                  }}
                >
                  {config.name}
                </span>
              </button>
            ))}
          </div>
        ) : null}

        {onStartWithoutCategory ? (
          <button
            type="button"
            onClick={onStartWithoutCategory}
            style={{
              marginTop: 20,
              width: "100%",
              height: 44,
              border: "none",
              borderRadius: 8,
              background: tokens.cardBg,
              color: tokens.text,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {intl.formatMessage({
              id: "chat.direct_chat",
              defaultMessage: "直接开始对话",
            })}
          </button>
        ) : null}
      </div>
    </V2PageFrame>
  );
};

export default UCCategoryPage;
